<div
  class="header-container"
  fxLayout="row"
  fxLayoutAlign="space-between start"
>
  <h3>
    {{
      'lib_calendar.appointment-chat-box.text.chat-with'
        | translate : { name: getNameOfOpposite() }
    }}
  </h3>

  <div>
    <button
      *ngIf="displayCloseButton"
      mat-icon-button
      (click)="closeClicked.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="chat-container">
  <div #messageContainer class="message-container">
    <ng-container *ngFor="let message of appointment?.messages">
      @if (isOwnerOfMessage(message.sender)) {
      <div class="flex-column-end">
        <div class="owner-message-wrapper">
          <div>{{ message.text }}</div>
        </div>
        <div class="message-timestamp">
          {{ message.createdTime | dateParser | weekdayFormatter : true }}
          {{ message.createdTime | dateParser | dateFormatter }}
          {{ message.createdTime | dateParser | timeFormatter }}
        </div>
      </div>
      } @else {
      <div class="flex-column-start">
        <div class="opposite-message-wrapper">
          <div>{{ message.text }}</div>
        </div>
        <div class="message-timestamp">
          {{ message.createdTime | dateParser | weekdayFormatter : true }}
          {{ message.createdTime | dateParser | dateFormatter }}
          {{ message.createdTime | dateParser | timeFormatter }}
        </div>
      </div>
      }
      <lib-spacer></lib-spacer>
    </ng-container>
  </div>

  <lib-spacer></lib-spacer>

  <mat-form-field>
    <mat-label>{{
      'lib_calendar.appointment-chat-box.text.message' | translate
    }}</mat-label>
    <textarea
      [formControl]="inputControl"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
    ></textarea>
    <button
      mat-icon-button
      matSuffix
      color="primary"
      [disabled]="!isAbleToSendMessage()"
      (click)="writeMessage()"
    >
      <mat-icon>send</mat-icon>
    </button>
  </mat-form-field>
</div>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
